import React, {ReactNode} from 'react'
import {FloatingPortal} from '@floating-ui/react'

interface DialogPortalProps {
    children?: ReactNode
}

export function DialogPortal({
    children,
}: DialogPortalProps) {
    return (
        <FloatingPortal>
            {children}
        </FloatingPortal>
    )
}
